// @ts-nocheck


import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../components/ant/DatePicker';

import { Filter, FilterButtonsContainer, FilterContainer, FilterItem, Selects } from './../../../components';
import Field from './../../../components/card/Field';

import { formatDateTimeToISOString } from './../../../lib/helpers';



const { OsagoCalculationStatusSelect, YearSelect } = Selects;

const SpoilerContent = styled.div.withConfig({ displayName: "FilterYearList__SpoilerContent", componentId: "sc-9fpe4n-0" })(["padding:16px;"]);
















export default ({ filter, cleanFilter, applyFilter }) =>
<SpoilerContent>
    <FilterContainer>
      <Filter
      cleanFilter={cleanFilter}
      applyFilter={applyFilter}
      initialValues={filter}>

        {({
        values,
        changeValue,
        applyFilter,
        cleanFilter
      }) =>
      <>
            <FilterItem>
              <Field mBottomNone>
                <OsagoCalculationStatusSelect
              size="small"
              onChange={(value) => changeValue('status', value)}
              value={values.status} />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <DatePicker
              size="small"
              format="DD.MM.YYYY"
              value={values.created && moment.utc(values.created)}
              placeholder="Дата создания карточки"
              onChange={(value, dateString) =>
              changeValue(
                'created',
                formatDateTimeToISOString(value, dateString)
              )
              } />

              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <YearSelect
              size="small"
              onChange={(value) => changeValue('year', value)}
              value={values.year} />

              </Field>
            </FilterItem>

            <FilterButtonsContainer
          applyFilter={applyFilter}
          cleanFilter={cleanFilter} />

          </>
      }
      </Filter>
    </FilterContainer>
  </SpoilerContent>;
